export const getTheme = () => document.documentElement.dataset.theme || "dark";

export const setTheme = (t, persist = true) => {
    document.documentElement.dataset.theme = t;
    if (persist) {
        try {
            localStorage.setItem("varasun-theme", t);
        } catch {
            /* private mode */
        }
    }
    window.dispatchEvent(new CustomEvent("vtheme", { detail: t }));
};

export const hasStoredTheme = () => {
    try {
        return !!localStorage.getItem("varasun-theme");
    } catch {
        return false;
    }
};
